export default __webpack_public_path__ + "static/media/online.744bdd3e.svg";